module.exports = __webpack_public_path__ + "img/47_24.1cd1ac27.png";